/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_TitleInputs */

const en_us2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs`)
};

const pt_br2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes`)
};

const es_419_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes`)
};

const pt_pt2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes`)
};

const fr_fr2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs`)
};

const de_de2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs`)
};

const it_it2_clubs_title = /** @type {(inputs: Clubs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club`)
};

/**
* | output |
* | --- |
* | "Clubs" |
*
* @param {Clubs_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_title = /** @type {((inputs?: Clubs_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_title(inputs)
	if (locale === "es-419") return es_419_clubs_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_title(inputs)
	return en_us2_clubs_title(inputs)
});
export { clubs_title as "clubs.title" }